import styles from "./kpi.module.css";

export default function KPI(props) {
  const { tall } = props;
  return (
    <div className={tall ? styles.kpi_wrapper_tall : styles.kpi_wrapper}>
      <div className={styles.kpi_title}>{props.title}</div>
      <div className={styles.kpi_value}>{props.value}</div>
    </div>
  );
}
